import { useEffect, useState, useRef } from "react";
import { formatRefOutput } from "../../Utility/referenceListing";

export const RightPanelRef = ({ editor, isShow, isOpen, showRef }) => {
  const [references, setReferences] = useState([]);

  useEffect(() => {
    if (editor?.dom && isShow === "ref" && isOpen) {
      const allRefs = editor.dom.select("ref");
      const allXrefs = editor.dom.select("xref");

      if (allRefs && allRefs.length > 0) {
        const newReferences = [];
        allRefs.forEach((item) => {
          const citation = item.querySelector("mixed-citation");
          const ref = citation?.querySelector("refoutput");
          const id = item.getAttribute("id");
          const output = formatRefOutput(ref);
          if (ref && id) {
            const xrefCount = Array.from(allXrefs).filter((xref) => {
              const refType = xref.getAttribute("ref-type") || "";
              if (refType !== "bibr") return false;
              const href = xref.getAttribute("href") || "";
              const rid = xref.getAttribute("rid") || "";
              const idNum = id.match(/\d+/)?.[0];
              const hrefNum = href.match(/\d+/)?.[0];
              const ridNum = rid.match(/\d+/)?.[0];
              return !!(idNum && (idNum === hrefNum || idNum === ridNum));
            }).length;
 
            newReferences.push({
              text: output,
              id: id,
              count: xrefCount,
            });
          }
        });
 
        setReferences(newReferences);
      }
    }
  }, [isShow, isOpen, showRef]);

  const selectRefInEditor = (id) => {
    if (!editor || !id) return;

    const dom = editor.dom;
    const queryEle = dom.select(`ref[id="${id}"]`)[0];

    if (queryEle) {
      editor.selection.select(queryEle);
      // queryEle.focus();
      queryEle.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const xrefIndicesRef = useRef({});
 
  const handleClick = (id) => {
    const editorBody = editor?.dom;
    if (!editorBody) return;
 
    const allXrefs = editorBody.select("xref");
    const idNum = id.match(/\d+/)?.[0];
    const xrefs = Array.from(allXrefs).filter((xref) => {
      const refType = xref.getAttribute("ref-type") || "";
      if (refType !== "bibr") return false;
      const href = xref.getAttribute("href") || "";
      const rid = xref.getAttribute("rid") || "";
      const hrefNum = href.match(/\d+/)?.[0];
      const ridNum = rid.match(/\d+/)?.[0];
      return !!(idNum && (idNum === hrefNum || idNum === ridNum));
    });
 
    if (!xrefs.length) return;
 
    if (xrefIndicesRef.current[id] === undefined) {
      xrefIndicesRef.current[id] = 0;
    }
 
    const currentIndex = xrefIndicesRef.current[id] % xrefs.length;
    const targetElement = xrefs[currentIndex];
 
    if (targetElement) {
      editor.selection.select(targetElement);
      targetElement.focus();
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
 
    xrefIndicesRef.current[id] = (xrefIndicesRef.current[id] + 1) % xrefs.length;
  };

  return (
    <div
      className={`w-full flex flex-col gap-4 ${
        isShow === "ref" ? "flex" : "hidden"
      }`}
    >

      {references.length > 0 ? (
        <div className="flex flex-col gap-3">
          {references.map((item, i) => (
              <div
                key={i}
                className="relative w-full flex  flex-col cursor-pointer bg-white rounded-md hover:bg-panelrefbg border border-grey py-2 px-[6px] hover:border-panelref "
              >
                <div
                  onClick={() => selectRefInEditor(item.id)}
                  className="flex w-full gap-[4px] pb-4"
                >
                  <span>{`[${item.id.match(/\d+/) ? item.id.match(/\d+/)[0] : (i + 1)}]`}</span>
                  <p className="text-[15px] break-all">{item.text}</p>
                </div>
                <div className="flex justify-end z-9 absolute bottom-[8px] right-[8px]">
                  <span
                    onClick={() => handleClick(item.id)}
                    className="text-[12px] text-green hover:text-red "
                  >
                    cited{`(${item.count})`}
                  </span>
                </div>
              </div>
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
